import { render, staticRenderFns } from "./PasmoAppDownloadPanel.vue?vue&type=template&id=2a27e3bc&"
import script from "./PasmoAppDownloadPanel.vue?vue&type=script&lang=ts&"
export * from "./PasmoAppDownloadPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports